import AppContainer from './App';

export default AppContainer;
